// Dynamic scanning of documents from assets/documents directory
const documentContext = require.context("../assets/documents", false, /^.*\.[^\\/]+$/)

// Convert the context to a documents array
const documents = documentContext.keys().map(key => {
  const filename = key.replace("./", "")
  const name = filename.replace(/\.[^/.]+$/, "").replace(/_/g, " ")

  return {
    name: name,
    filename: filename,
    url: documentContext(key)
  }
})

// Export function to get documents
export const getDocuments = () => {
  return documents
}

// Get file icon based on extension
export const getFileIcon = filename => {
  const extension = filename.split(".").pop().toLowerCase()
  switch (extension) {
    case "pdf":
      return "fas fa-file-pdf text-danger"
    case "docx":
    case "doc":
      return "fas fa-file-word text-primary"
    case "xlsx":
    case "xls":
      return "fas fa-file-excel text-success"
    default:
      return "fas fa-file text-muted"
  }
}
